import React from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "../PersonalAccidentCover/PersonalAccidentCoverStyle.scss";
import { useTranslation } from "react-i18next";
import { updateLeadsLife } from "../../Redux/LogsRedux/Life/LifeLeadsRedux";
import { useState } from "react";
import AddBeneficiary from "../Beneficiary/Beneficiary";

function PersonalAccidentCover({ planDetails }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t,i18n } = useTranslation();
  const [isSelected, setIsSelected] = useState(true);
  const [showError, setShowError] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [updatedData, setUpdatedData] = useState();
  // const { planDetails } = location.state || {};

  const downloadDetails = [
    {
      label: "Download Table Of Benefits",
      //   link: affordableHealth,
      filename: "Table-of-benefits.pdf",
    },
  ];

  const data = {
    selectedPlanAmount: planDetails?.personalAccident?.premium,
    annualLimit: "2 Years Coverage",
    opDetectable: "Nil",
    coPay: "Nil",
    inPatientCoverage: 4000,
    outPatientCoverage: 500,
    sumAssured: planDetails?.personalAccident?.sum_assured,
    deathClaim: "3,000.000",
    permanentTotal: "3,000.000",
    partialDisabledDue: "3,000.000",
    deathDue: "1,000.000",
    medicalExpenses: "500.000",
    mortalRemains: "400.000",
    airticket: "100.000",
  };

  const handleSelect = () => {
    setIsSelected(true);
    setShowError(false);
  };

  const handleConfirm = () => {
    if (!isSelected) {
      setShowError(true);
      return;
    }
    const payload = {
      transId: localStorage.getItem("LIFE_LEAD_ID"),
      selectedSumAssured: data,
    };
    dispatch(updateLeadsLife(payload)).then((response) => {
      if (response.success) {
        const updatedData = {
          ...planDetails,
          selectedLimit: data,
        };
        setUpdatedData(updatedData);
        setShowConfirm(true);
      }
    });
  };

  const handleSubmit = async (plan) => {
    const payload = {
      transId: localStorage.getItem("LIFE_LEAD_ID"),
      selectedSumAssured: data,
    };
    dispatch(updateLeadsLife(payload)).then((response) => {
      if (response.success) {
        const updatedData = {
          ...planDetails,
          selectedLimit: data,
        };
        navigate("/add-beneficiary", {
          state: { planDetails: updatedData },
        });
      }
    });
  };

  return (
    <>
      <div className="row mt-2">
        <div className="col-md-12 p-3">
          {/* <h3 className="title pt-2 mb-2">{t(planDetails?.coverPlan)}</h3> */}
          <h5 className="title subHeader p-0 fw-bold mb-2">
            {t("choose your plan")}
          </h5>
        </div>
      </div>

      <div className="row plan-grid justify-content-center">
        <div className="col-lg-12 col-md-12">
          <div
            className={`plan-card-ind mb-4 p-4 ${isSelected ? "active-plan" : ""}`}
            role="button"
            tabIndex={0}
            onClick={handleSelect}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleSelect();
              }
            }}
          >
            <div className="plan-info p-1">
              <p className="plan-label">{t("Premium")}</p>
              <p className="plan-price">
                <span className="price-amount">
                  {(() => {
                    const premium = Number(
                      planDetails?.personalAccident?.premium,
                    );

                    return Number.isInteger(premium)
                      ? `${premium}.000`
                      : premium;
                  })()}
                </span>
                <span className="price-currency"> OMR</span>
              </p>
              <hr />
              <p className="plan-name u">
                {" "}
                {t("Sum Assured")} {data?.sumAssured}
              </p>
              <div className="row">
                <div className="col-md-6 p-1">
              <ul className="plan-benefits-list">
                    <li className="plan-benefits my-1">{t(data?.annualLimit)}</li>

                    <li className="plan-benefits mb-1">
                  {t("Death due to an accident")} {data?.deathClaim}
                </li>

                    <li className="plan-benefits mb-1">
                  {t("Permanent Total Disablement due to an accident")}{" "}
                  {data?.permanentTotal}
                </li>

                    <li className="plan-benefits mb-1">
                  {t("Permanent Partial Disablement due to an accident")}{" "}
                  {t("% of Sum Assured as certified by Govt Medical Board")}{" "}
                  {data?.partialDisabledDue}
                </li>
                  </ul>
                </div>
                <div className="col-md-6 p-1">
                  <ul className="plan-benefits-list">
                    <li className="plan-benefits my-1">
                      {t("Death Due to any reason (Other than Accident)")}{" "}
                      {data?.deathDue}
                    </li>

                    <li className="plan-benefits mb-1">
                      {t("Medical Expenses due to an accident (Up to)")}{" "}
                      {data?.medicalExpenses}
                    </li>

                    <li className="plan-benefits mb-1">
                      {t("Repatriation of Mortal Remains to home country (Up to)")}{" "}
                      {data?.mortalRemains}
                    </li>

                    <li className="plan-benefits mb-1">
                      {t("Air ticket expenses for medically unfit to work (Up to)")}{" "}
                      {data?.airticket}
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
            </div>
            <div className="planSelect">
              <a
                className={`round ${isSelected ? "active" : ""}`}
                onClick={handleSelect}
              >
                <i
                  className={`bi bi-check-lg plan-select-icon ${isSelected ? "bi-check-lg" : "bi-plus"}`}
                ></i>
              </a>
            </div>
          </div>
          {!isSelected && showError && (
            <label className="text-danger d-flex justify-content-center m-0 p-0">
              Please select the plan
            </label>
          )}
        </div>
      </div>
      <div className="row justify-content-center pb-4">
        <div className="col-lg-4 col-md-4"></div>
        <div className="col-lg-4 col-md-4"></div>
        <div
          className={`col-lg-4 col-md-4 ${i18n.language === "ar" ? "text-start" : "text-end"} mb-2`}
        >
          <button
            type="button"
            onClick={handleConfirm}
            className="btn btn-primary"
          >
            {t("Next")}
          </button>
        </div>
        {showConfirm && updatedData && (
          <>
            <div
              className="modal fade show"
              style={{ display: "block" }}
              role="dialog"
              aria-modal="true"
            >
              <div
                className="modal-dialog modal-dialog-scrollable modal-dialog-centered"
                style={{ maxWidth: "900px", width: "95%" }}
              >
                <div className="modal-content ">
                  <div className="modal-body">
                    <AddBeneficiary
                      setShowConfirm={setShowConfirm}
                      planDetails={updatedData}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-backdrop fade show"></div>
          </>
        )}
      </div>
    </>
  );
}

export default PersonalAccidentCover;
